import dayjs from 'dayjs';

export default class Search {
  constructor(data) {
    this.direction = data?.direction;
    this.priority = data?.priority ?? dayjs().unix();
  }
}
